import MerchantHelpApi from '@/api/merchant-help'

const state = { }

const mutations = { }

const actions = {
  async allHelpConfigs ({ commit }, params) {
    const result = await MerchantHelpApi.allHelpConfigs(params)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-help.js